import React from 'react'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { Input } from 'components/inputs'
import { Validator } from 'components/validation'
import { PriceInCurrency } from 'components/price'

export const OrderedWineItem = ({ item, index, onDeliveredUnitsChange, onActualPriceChange, disabled, currencyName, exchangeRate }) => {
  return (
    <TableRow>
      <TableCell component='th' scope='row'>{item.wine.name}</TableCell>
      <TableCell align='right'>{`${item.orderedUnits} / ${item.inStockUnits}`}</TableCell>
      <TableCell>
        <Validator name={`deliveredUnits[${index}]`} value={item.deliveredUnits} required min={0}>
          <Input isNumeric disabled={disabled} value={item.deliveredUnits} onChange={x => onDeliveredUnitsChange(x, index)} />
        </Validator>
      </TableCell>
      <TableCell align='right'><PriceInCurrency currencyName={currencyName} price={item.priceInOrder} exchangeRate={exchangeRate} /></TableCell>
      <TableCell>
        <Validator name={`actualPrice[${index}]`} value={item.actualPrice} required>
          <Input isNumeric disabled={disabled} value={item.actualPrice} onChange={x => onActualPriceChange(x, index)} />
        </Validator>
      </TableCell>
    </TableRow>
  )
}